<template>
  <div class="travel-list-items ml-1" 
    v-if="
      isShow &&
      displayItem && 
      displayItem.travels && 
      displayItem.travels.length">
    <v-list-item
      class="travel-list-items__item mb-1 mt-1"
      v-for="(travel, index) in displayItem.travels"
      :key="'travel-' + index"
      three-line
      @click="openTravelsDialog(index)"
      >
      <v-list-item-content class="travel-list-items__item__content">
        <v-list-item-subtitle >
          {{travel.discription}}
        </v-list-item-subtitle>
        <v-list-item-title class="travel-list-items__item__title mt-1">
          <span>{{travel.startSection}}</span>
          <v-icon small class="ml-1 mr-1">{{travel.sectionType ? 'mdi-arrow-u-left-bottom': 'mdi-arrow-right'}}</v-icon>
          <span>{{travel.endSection}}</span>
          <span class="travel-list-items__item__transportation">
            （{{travel.transportation}}）
          </span>
        </v-list-item-title>
        <v-list-item-subtitle class="mt-1">
          {{travel.amount.toLocaleString()}}<span class="ml-1">円</span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action style="align-self: center;">
        <v-btn icon @click.stop="remove(travel.id)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </div>        
</template>

<script>

  export default {
    props: ["common", "data", "dialog", "displayItem"],
    data: () => ({
      isShow: true,
    }),
    methods: {
      openTravelsDialog(index) {
        this.dialog.year = this.displayItem.date.get("year")
        this.dialog.month = this.displayItem.date.get("month") + 1
        this.dialog.day = this.displayItem.date.get("date")
        this.dialog.travel = this.displayItem.travels[index]
        this.common.eventBus.$emit('TravelsDialog.open')
      },
      remove(id) {
        this.deleteTravel(id)
        .then(() => {
          this.isOpen = false
          this.common.eventBus.$emit('App.reload')
        })
        .catch(err => {
          this.errorProcess(err)
        })
      },
      reload() {
        this.isShow = false
        this.isShow = true
      },
    },
    created() {
      this.common.eventBus.$on('TravelListItems.reload', this.reload)
    },
}
</script>

<style scoped>
  .travel-list-items {
    text-align: left;
  }
  .travel-list-items__item {
    border-left: 5px solid var(--travelColor);
  }
  .travel-list-items__item__content {
    color: var(--textColor-default)
  }
  .travel-list-items__item__title {
    display: flex;
    align-items: center;
  }
  .travel-list-items__item__transportation {
    font-size: small;
  }
</style>
